import { useMemo, useState } from 'react'
import { historicoConferenciaOrdemColeta } from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_INITIAL_INFO: 'Adquirindo dados da conferencia',
}

const INITIAL_STATE = {
  conferencia: {
    total_caixas: 0,
    total_caixas_vol: 0,
    total_caixas_uni: 0,
    total_bipado: 0,
    total_bipado_vol: 0,
    total_bipado_uni: 0,
    bip_history: [],
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useConferenciaOrdemColeta() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getInitialInfo(ordem_coleta_id) {
        historicoConferenciaOrdemColeta(ordem_coleta_id)
          .then(result =>
            setState(prevState => ({
              ...prevState,
              conferencia: result,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events

      onInit(selectedTp) {
        if (!selectedTp) setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        else
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_INITIAL_INFO }))
      },
    }
  }, [])

  return { state, localDispatch }
}
